import type { ComponentPropsWithRef } from "react";
import type { WithRequired } from "@/types";
import { cn } from "@/utils/style.ts";

type DropdownProps = WithRequired<ComponentPropsWithRef<"select">, "id">;
function Dropdown({ children, className, ...props }: DropdownProps) {
    return (
        <select {...props} className={cn("dropdown", className)}>
            {children}
        </select>
    );
}

function DropdownOption({ children, ...props }: ComponentPropsWithRef<"option">) {
    return <option {...props}>{children}</option>;
}

export { Dropdown, DropdownOption };
